import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { LocationAccuracy } from '@awesome-cordova-plugins/location-accuracy/ngx';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  Platform,
  ToastController,
} from '@ionic/angular';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';
import { CalendarComponentOptions } from 'ion2-calendar';
import { Observable } from 'rxjs';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
// import { IonDatetime } from '@ionic/angular';
import { format, parseISO, getDate, getMonth, getYear } from 'date-fns';
// import {format} from 'moment';
declare var google;
@Component({
  selector: 'app-order-settings',
  templateUrl: './order-settings.page.html',
  styleUrls: ['./order-settings.page.scss'],
})
export class OrderSettingsPage implements OnInit {
  // @ViewChild(IonDatetime, { static: true }) datetime: IonDatetime;
  @Input('category_page') category_page;
  @Input('branchId') branchId;
  type: string;
  orderSettings: any;
  time: any;
  dateValue = '';
  productName: any;
  future_time: any;
  CurrentAdress: boolean = true;
  NewAddress: boolean;
  ProcessForm: FormGroup;
  Address: string;
  zipcode: string;
  city: string;
  state: string;
  segmentValue: any;
  min: any;
  hours: any;
  future_hours: any;
  future_min: any;
  day: any;
  scheduled_time: any;
  current_adress: any;
  // year: any;
  // month: any;
  datenow: any;
  current: any;
  myDate: any;
  // value: string;
  // deliver_now: boolean = true;
  public unregisterBackButtonAction: any;
  deliveryTime: any;
  new_time: any;
  //current_Time :any ;
  date: any;

  forToday: any;
  convertDate: any;
  pickup_time: any;
  month_array: any[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  timeArray = [
    '12:00 AM',
    '12:30 AM',
    '01:00 AM',
    '01:30 AM',
    '02:00 AM',
    '02:30 AM',
    '03:00 AM',
    '03:30 AM',
    '04:00 AM',
    '04:30 AM',
    '05:00 AM',
    '05:30 AM',
    '06:00 AM',
    '06:30 AM',
    '07:00 AM',
    '07:30 AM',
    '08:00 AM',
    '08:30 AM',
    '09:00 AM',
    '09:30 AM',
    '10:00 AM',
    '10:30 AM',
    '11:00 AM',
    '11:30 AM',
    '12:00 PM',
    '12:30 PM',
    '01:00 PM',
    '01:30 PM',
    '02:00 PM',
    '02:30 PM',
    '03:00 PM',
    '03:30 PM',
    '04:00 PM',
    '04:30 PM',
    '05:00 PM',
    '05:30 PM',
    '06:00 PM',
    '06:30 PM',
    '07:00 PM',
    '07:30 PM',
    '08:00 PM',
    '08:30 PM',
    '09:00 PM',
    '09:30 PM',
    '10:00 PM',
    '10:30 PM',
    '11:00 PM',
    '11:30 PM',
  ];
  banner: any;
  Images: any;
  time_: any;
  NEW: any = false;
  lat: number;
  long: number;
  coordinates: any;
  order_pickup = this.globals.pickup;
  order_delivery = this.globals.delivery;
  // category_page: any;
  // branchId: any;
  radius_value: number;
  value: any;
  pickuptype = 'Asap';
  deliverytype = 'Asap';
  @ViewChild('searchbar', { read: ElementRef }) searchbar: ElementRef;
  @ViewChild('map') mapElement: ElementRef;
  addressElement: HTMLInputElement = null;
  map: any;
  showpickOptions: boolean = true;
  showdeliveryOptions: boolean = true;
  myPDate: any;
  pickupTime: any;
  dateNow: string;
  optionsCal: CalendarComponentOptions = {
    from: new Date(),
    color: 'primary',
    pickMode: 'single',
  };
  datea: string;
  types: 'string';
  selecteddate: any;
  showcalender: boolean = false;
  showtime: boolean = false;
  pickupTimeSlots: any = [];
  constructor(
    public loadingCtrl: LoadingController,
    public server: ServerService,
    public geolocation: Geolocation,
    public alertCtrl: AlertController,
    public navCtrl: NavController,
    public formBuilder: FormBuilder,
    public globals: GlobalVariable,
    public modalCtrl: ModalController,
    public nativeStorage: NativeStorage,
    public plt: Platform,
    private locationAccuracy: LocationAccuracy,
    public androidPermissions: AndroidPermissions,
    private toastController: ToastController
  ) {
    this.segmentValue = localStorage.getItem('segmentvalue');
    this.deliveryTime = this.globals.pickupsetting;
    this.pickup_time = this.globals.pickup_Time;
    // this.category_page = this.navParams.get('category_page')
    // this.branchId = this.navParams.get('branchId');
    this.type = this.globals.OrderType;
    console.log('in type of pickup??', this.type);
    console.log('Pick Up -> ', this.globals.pickupsetting);
    console.log('Segment value -> ', this.segmentValue);
    // console.log("gloabl value -> ", this.globals)
    this.globals.order_time = 'schedule';
    // this.pickupTime=this.globals.myDate;
    // this.pickupTime= this.pickupTime.replace('T', ' ');
    // this.pickupTime= this.pickupTime.slice(0,16);

    //this.type = localStorage.getItem("type");
    // this.checktype();
    //console.log("localstorage data for testing ", localStorage.getItem("type"));
    if (this.globals.address == '') {
      this.globals.checkGPSPermission();
      this.CurrentAdressBox();
    } else {
      console.log('p-1.1');
      // this.reverseGeoCoding(this.globals.lat, this.globals.long)
    }

    this.ProcessForm = formBuilder.group({
      Address: ['', Validators.compose([Validators.required])],
      // zipcode: ['', Validators.compose([Validators.required])],
      // city: ['', Validators.compose([Validators.required])],
      // state: ['', Validators.compose([Validators.required])],
    });

    // this.unregisterBackButtonAction && this.unregisterBackButtonAction();
    // this.plt.registerBackButtonAction(() => {
    // }, 1);
    this.min_date_value();
  }

  ngOnInit() {}
  segmentChanged(e) {
    console.log(e);
    this.globals.OrderType = e.detail.value;
  }
  schSegment;
  // onDateChange(e) {
  //   console.log('event', e);
  //   this.date = e.format('yyyy/MM/dd');
  //   // this.date=e.format('MM/DD/YYYY');
  //   console.log('here', this.date);
  //   this.showcalender = false;

  //   this.getTimeSlots();
  // }
  closetohome() {
    // this.viewCtrl.dismiss();
    this.navCtrl.navigateRoot('home');
  }
  setTime(time) {
    if (this.date == undefined || this.date == '') {
      this.globals.presentToast('Select date first');
      return;
    }
    this.globals.presentToast('Please wait..', 500);

    // let type = time.slice(5,8);
    //  let hours=time.slice(0,2);
    //  let minutes=time.slice(3,5)
    //   console.log(hours,minutes,type.toLowerCase())
    //   var timeString = hours + ':' + minutes + ':' +type;
    // new Date((date.getTime()) - date.getTimezoneOffset() * 60000).toISOString();
    console.log('time', time);
    var dateObj = new Date(this.date + ' ' + time.time_start);
    let newdate = new Date(
      dateObj.getTime() - dateObj.getTimezoneOffset() * 60000
    );
    // this.date = new Date(new Date().setHours(new Date().getHours()));
    // var timeis = new Date(this.date).toLocaleString('en-US', { hour12: true });
    // this.showDate=newdate
    console.log(newdate, 'newdate');
    console.log(newdate.toISOString(), 'sda');
    this.globals.myDate = newdate.toISOString();
    // let date=new Date(temp).getTime().toLocaleString()
    console.log(dateObj);
    // sdfsd
    this.showtime = false;
    this.process();
  }
  //new
  formatDate(e) {
// let date=new Date(e.detail.value)
// let day=date.getUTCDay();
// let month=date.getUTCMonth();
// let year=date.getUTCFullYear();
let date=new Date(e.detail.value).toISOString()
    this.date = format(parseISO(date), 'MM/dd/yyyy');
    // this.date=month+'/'+day+'/'+year
    console.log(date,this.date);

    // this.date = e.detail.value;
    // console.log(dateObj)
    // let newdate=new Date((dateObj.getTime()) - dateObj.getTimezoneOffset() * 60000);
    // this.date=newdate.format('yyyy/MM/dd');
    // let date=format(parseISO(e.detail.value), 'yyyy/MM/dd');
    // newdate = format(parseISO(newdate), 'MMM dd yyyy');
    // console.log(newdate);
    this.getTimeSlots();
  }
  // reset(e)
  //new
  getTimeSlots() {
    this.pickupTimeSlots=[]
    if (this.date == undefined || this.date == '') {
      this.globals.presentToast('Select date first');
      return;
    }
    this.globals.presentToast('Please wait..', 1000);

    let date = new Date();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    // let time=date.getTime()
    let ampm = hours >= 12 ? 'pm' : 'am';
    // var time: any = date.getHours() + ":" + date.getMinutes();
    let time = hours + ':' + minutes;
    // if(hours>12){

    // }
    console.log(hours, ' ', minutes, ' ', ampm);

    this.server
      .getPickupslots(this.globals.bussinessId, this.date + ' ' + time)
      .subscribe(
        (res) => {
          console.log(res);
          if (res.status) {
            this.showtime = true;
            this.pickupTimeSlots = res.slots;

         
            setTimeout(() => {
              let id = document.getElementById('time');
              console.log('id to scroll  ',id)
            id.scrollIntoView({ behavior: 'smooth', block:'start' });
              
            }, 1000);
          } else {
            this.globals.presentToast(res.message);
          }
          console.log(res);
        },
        (err) => {
          console.log(err);
          this.globals.presentToast('Something went wrong,try again later');
        }
      );
  }
  chooseDate() {
    if (this.showcalender == false) {
      this.showcalender = true;
    } else {
      this.showcalender = false;
    }
    this.showtime = false;
  }
  chooseTime() {
    if (this.date == undefined || this.date == '') {
      this.globals.presentToast('Select date first');
      return;
    }
    this.showcalender = false;

    if (this.showtime == false) {
      this.showtime = true;
    } else {
      this.showtime = false;
    }
  }
  toggleOptionsDel() {
    this.showdeliveryOptions = true;
    // this.showpickOptions=false;
  }
  toggleOptionspick() {
    this.showpickOptions = true;
    // this.showdeliveryOptions=false;
  }
  savePickup() {
    this.showpickOptions = false;
  }
  saveDelivery() {
    this.showdeliveryOptions = false;
  }

  ionViewDidLoad() {
    var that = this;
    setTimeout(function () {
      that.loadMaps();
    }, 2000);
  }

  min_date_value() {
    var date = new Date();

    var datenow = date.getDate().toString();
    // var datenow  =moment().format('yyyy/MM/dd HH:mm');

    var month = (date.getMonth() + 1).toString();
    var year = date.getFullYear().toString();

    if (month.length < 2) month = '0' + month;
    if (datenow.length < 2) datenow = '0' + datenow;
    this.value = year + '-' + month + '-' + datenow;
    this.value.toString();

    console.log('value', this.value);

    // var date1 = moment().format('yyyy/MM/dd HH:mm');
    var date1 = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    ).toISOString();
    this.dateNow = date1;
    if (!this.globals.myDate) {
      // this.globals.myDate = date1;
      // localStorage.setItem('scheduled_time',this.globals.myDate);
      // this.myPDate=moment().format('MMMM Do YYYY, h:mm:ss a');
      // this.myPDate=this.globals.myDate
      // console.log('date is,',this.myPDate)
    }
  }

  loadMaps() {
    if (google) {
      this.initAutocomplete();
    } else {
      this.globals.presentToast(
        'Something went wrong with the Internet Connection. Please check your Internet.'
      );
    }
  }

  initAutocomplete(): void {
    this.addressElement =
      this.searchbar.nativeElement.querySelector('.searchbar-input');
    this.createAutocomplete(this.addressElement).subscribe((location) => {
      console.log('location', location);
    });
  }

  createAutocomplete(addressEl: HTMLInputElement): Observable<any> {
    const autocomplete = new google.maps.places.Autocomplete(addressEl);
    //autocomplete.bindTo('bounds', this.map);
    return new Observable((sub: any) => {
      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        console.log('place', place);

        var address = [
          (place.address_components[0] &&
            place.address_components[0].long_name) ||
            '',
          (place.address_components[1] &&
            place.address_components[1].long_name) ||
            '',
          (place.address_components[2] &&
            place.address_components[2].long_name) ||
            '',
        ].join(' ');
        this.globals.address = address;
        if (!place.geometry) {
          this.globals.locationSelected = false;
          sub.error({
            message: 'Autocomplete returned place with no geometry',
          });
        } else {
          this.globals.locationSelected = true;
          this.lat = place.geometry.location.lat();
          this.long = place.geometry.location.lng();
          this.reverseGeoCoding(this.lat, this.long);

          sub.next(place.geometry.location);
          //sub.complete();
        }
      });
    });
  }

  tConvert(time) {
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }

  getdata() {
    this.time = localStorage.getItem('scheduled_time');
    console.log('time - get data', this.time);

    if (this.time) {
      if (this.globals.specific_delivery_day == 'false') {
        var res = this.time.split('T');

        var res1 = res[1].split('.');
        this.datenow = res[0] + ' ' + this.tConvert(res1[0]);
        this.convertDate = res[0] + ' ' + this.tConvert(res1[0]);
      } else {
        var res1 = this.time.split('00');
        this.convertDate = res1[0];
        this.datenow = res1[0];
      }

      // this.date = new Date(this.time );
      // var timeis = new Date(this.time).toLocaleString('en-US', { hour12: true });
    } else {
      this.date = new Date(new Date().setHours(new Date().getHours()));
      var timeis = new Date(this.date).toLocaleString('en-US', {
        hour12: true,
      });
      this.datenow = timeis;

      this.convertDate = timeis;
    }

    //this.date = new Date(local_datetime);

    // let timeis =  new Date(this.time).toJSON().split('T')[0];
    // this.convertDate.toString();
    //   let hourss = this.date.getHours();
    //   let mins = this.date.getMinutes();
    // let dayyy = this.date;

    //   let local_datetime = new Date(this.time).toLocaleString('en-US', { hour12: false });
    //       this.date = new Date(local_datetime );
    // console.log("getting time", localStorage.getItem("scheduled_time"),this.convertDate , "local date", this.date);
    //   this.nativeStorage.getItem('orderdetail').then(data => {
    //     this.time = data.scheduled_time;
    //     this.time = this.time.toJSON().split('.')[0];
    //     this.productName = data.name;

    //     //this.type = data.type;

    // }, error => {
    //     this.time = 'Apr,10,2018'

    // }).catch(err => console.log(err));
    // console.log("checking type",this.type,this.time);
  }

  onsegmentChanged() {
    // this.loadMap(this.lat,this.long)
    this.globals.checkGPSPermission();
    this.CurrentAdressBox();
    if (this.type == 'delivery') {
      this.globals.OrderType = 'delivery';
      // this.segmentValue = "Asap"
      this.globals.delivery == true;
      // localStorage.setItem("type","delivery" )
    } else {
      this.globals.OrderType = 'pickup';
      // this.segmentValue = "Asap"
      this.globals.pickup == true;
      //localStorage.setItem("type","pickup" );
    }
  }
  // geolocate() {
  //   let options = {
  //     enableHighAccuracy: true
  //   };

  //     this.geolocation.getCurrentPosition(options).then((position: Geoposition) => {
  //     this.getcountry(position);
  //   }).catch((err) => {
  //     alert(err);
  //   })

  // }

  // getcountry(pos) {
  //   this.nativeGeocoder.reverseGeocode(pos.coords.latitude, pos.coords.longitude).then((res: NativeGeocoderReverseResult) => {
  //     alert("get address" + res.countryName);
  //   })
  // }
  // checktype(){

  //   if(this.type == "delivery"){

  //     localStorage.setItem("type","delivery" );
  //     this.type = "delivery"
  //     console.log("localstorage data delivery", localStorage.getItem("type"));
  //   }
  //   else{
  //     localStorage.setItem("type","pickup" );
  //     this.type = "pickup"
  //     console.log("localstorage data pickup ", localStorage.getItem("type"));
  //   }

  // }
  // getOrderTime(){
  //   this.nativeStorage.getItem('orderdetailtime').then(data => {
  //     this.future_time = data.future_order_time;

  // }, error => {
  //     this.time = 'Apr,10,2018'

  // }).catch(err => console.log(err));

  // }

  ionViewWillEnter() {
    // if(this.globals.myDate)

    //   this.getCurrentLocation().then((resp) => {
    //   this.reverseGeoCoding(resp.coords.latitude, resp.coords.longitude);
    // });

    //this.getdata();
    // if (!this.globals.OrderType) {

    //   if (this.order_pickup && !this.order_delivery) {
    //     this.type = "pickup";
    //     this.globals.OrderType = this.type;

    //   }
    //   else if (this.order_delivery) {
    //     this.type = "delivery";
    //     this.globals.OrderType = this.type;
    //   }
    // }
    // else {

    this.type = this.globals.OrderType;
    // }
  }

  dateChanged() {
    console.log('time', this.globals.myDate);
    localStorage.setItem('scheduled_time', this.globals.myDate);
  }

  dismiss() {
    this.modalCtrl.dismiss({ date: this.globals.myDate });
  }

  process() {
    if (this.globals.order_time == 'schedule') {
      console.log(' pickup in scheduled');

      localStorage.setItem('scheduled_time', this.globals.myDate);
    } else {
      console.log('pickup now ');
      this.globals.myDate = this.dateNow;
      console.log('date now is ', this.globals.myDate);
      // localStorage.setItem("scheduled_time", this.globals.order_time);
      localStorage.setItem('scheduled_time', this.globals.myDate);
    }

    localStorage.setItem('GetAddress', this.globals.address);

    console.log('gloabl', this.globals);
    if (this.globals.OrderType == 'delivery') {
      this.checkTimingLater(this.globals.delivery_timing)
        .then((resp) => {
          if (
            this.globals.address != '' &&
            this.globals.address != undefined &&
            this.globals.inradius == true
          ) {
            console.log('delivery inside', this.globals);
            this.dismiss();
          } else {
            this.outsideDeliveryRadius();
          }
        })
        .catch((error) => {});
    } else {
      this.checkTimingLater(this.globals.pickup_timing)
        .then((resp) => {
          // debugger;
          this.dismiss();
        })
        .catch((error) => {
          // this.globals.presentToast('Sorry, we are not serving at this time. Please reschedule it.')
          // debugger;
        });
    }

    this.globals.save_check = true;
  }

  process_cancel() {
    if (this.globals.order_time == 'schedule') {
      // localStorage.setItem("scheduled_time", this.globals.myDate);
      console.log('order not scheduled');
      this.globals.myDate = undefined;
      localStorage.setItem('scheduled_time', undefined);
    } else {
      localStorage.setItem('scheduled_time', undefined);
    }

    localStorage.setItem('GetAddress', this.globals.address);

    this.dismiss();
  }

  // secondModal() {

  //   // this.checktype();
  //   //this.viewCtrl.dismiss();
  //   let modal = this.modalCtrl.create('Modal2Page', { category_page: this.category_page });
  //   modal.onDidDismiss(data => {
  //     console.log("Dismiss called ")
  //     this.segmentValue = localStorage.getItem("segmentvalue");
  //     this.deliveryTime = this.globals.pickupsetting;
  //     this.pickup_time = this.globals.pickup_Time;
  //     this.getdata();
  //     console.log("Pick Up -> ", this.globals.pickupsetting)
  //     console.log("Segment value -> ", this.segmentValue)
  //     if (data == 'CategoryPage') {
  //       this.category_page = 1;
  //       console.log(data, "dta", this.category_page)

  //     }
  //   });
  //   modal.present();

  // }

  getCurrentLocation(): Promise<any> {
    return new Promise((resolve) => {
      console.log('p-3.1 - get current location');
      if (this.globals.delivery == true) {
        this.geolocation
          .getCurrentPosition()
          .then((resp) => {
            console.log('p-3.2 - current location', resp);
            resolve(resp);
          })
          .catch((error) => {
            console.log('location error ');
            this.reverseGeoCoding(
              this.globals.latitude,
              this.globals.longitude
            );
          });
      }
    });
  }

  reverseGeoCoding(lat, lng) {
    // author: zohra
    // purpose : add delivery fee
    // used in app
    // created : old
    // last_modified: 2020-12-29 05:00
    // status: active old
    console.log('p-1.2');
    this.globals.lat = lat;
    this.globals.long = lng;
    var mycoordinates = lat + ',' + lng;
    let response = this.server.getAddress(mycoordinates, this.branchId);
    var myadress = '';
    response.subscribe(
      (data) => {
        console.log('p-4.1');
        this.loadMap(lat, lng);
        myadress = data.address;
        this.globals.address = myadress;
        this.globals.delivery_fee = data.delivery_meta.delivery_fee;

        this.globals.inradius = data.in_radius;

        if (data.delivery_meta && data.delivery_meta.id) {
          this.globals.pickupsetting = data.delivery_meta.delivery_time;
          this.globals.minimun_order =
            data.delivery_meta.delivery_minimum_order;
          this.globals.deliveryCharges = data.delivery_meta.delivery_fee;
        }
        if (data.in_radius == false) {
          if (this.globals.pickup == true) {
            this.type = 'pickup';
            this.globals.OrderType = this.type;
          } else {
            this.outsideDeliveryRadius();
          }
        }
        localStorage.setItem('GetAddress', myadress);
      },
      (error) => {
        localStorage.setItem('GetAddress', '');

        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }
  outsideDeliveryRadius() {
    this.globals.presentToast(
      'Sorry',
      'Your location is out of our delivery radius.'
    );
  }

  Getscheduletime() {
    //commented by jahanzaib
    // this.viewCtrl.dismiss();
    // this.navCtrl.pop();
    // let modal = this.modalCtrl.create('Modal2Page');
    // modal.onDidDismiss(data => {
    //   console.log("Dismiss called schedule time")
    //   this.segmentValue = localStorage.getItem("segmentvalue");
    //   this.deliveryTime = this.globals.pickupsetting;
    //   this.pickup_time = this.globals.pickup_Time;
    //   this.getdata();
    //   console.log("Pick Up -> ", this.globals.pickupsetting)
    //   console.log("Segment value -> ", this.segmentValue)
    //   if (data == 'CategoryPage') {
    //     this.category_page = 1;
    //     console.log(data, "dta", this.category_page)
    //   }
    // });
    // modal.present();
  }
  // loadMap(lati, longi) {
  //   console.log("p-5.1")
  //   // var latlng = this.coordinates.split(",")
  //   var myLatLng = new google.maps.LatLng(lati, longi);

  //   this.map = new google.maps.Map(document.getElementById('map'), {
  //     zoom: 15,
  //     center: myLatLng
  //   });
  //   console.log("p-5.2 -- ", this.map);

  //   var marker = new google.maps.Marker({
  //     position: myLatLng,
  //     map: this.map,
  //     title: ''
  //   });

  // }
  //load map ....
  loadMap(lati, longi) {
    console.log(this.mapElement);

    let mapOptions = {
      center: {
        lat: lati,
        lng: longi,
      },
      fullscreenControlOptions: false,
      mapTypeControl: false,

      zoom: 15,
      streetViewControl: false,
      zoomControl: false,
      fullscreenControl: false,
      keyboardShortcuts: false,

      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    console.log(lati, longi);
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    //  this.addMarker(position.coords.latitude,position.coords.longitude);
    this.addMarker(lati, longi);
  }

  addMarker(lat: number, lng: number) {
    console.log('Marker Cords', lat, lng);
    let latLng = new google.maps.LatLng(lat, lng);
    let marker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.DROP,
      position: latLng,
    });

    let content = '';

    this.addInfoWindow(marker, content);
  }
  addInfoWindow(marker, content) {
    let infoWindow = new google.maps.InfoWindow({
      content: content,
    });

    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, marker);
    });
  }

  //end of map
  CurrentAdressBox() {
    // this.NEW = true;
    console.log('p-2.1');
    if (this.CurrentAdress == true) {
      this.getCurrentLocation()
        .then((resp) => {
          console.log('p-2.2');
          // this.loadMap(resp.coords.latitude, resp.coords.longitude);
          this.reverseGeoCoding(resp.coords.latitude, resp.coords.longitude);
          this.NEW = false;
          this.lat = resp.coords.latitude;
          this.long = resp.coords.longitude;
        })
        .catch((e) => {
          console.log('Reverse coding');
          this.reverseGeoCoding(0, 0);
        });

      // this.Address =  localStorage.getItem("GetAddress");
      // this.city = "lahore";
      // this.zipcode = "54000";
      // this.state = "punjab";
      this.NewAddress = false;
    } else {
      this.NewAddress = true;
    }
  }

  NewAddressBox() {
    this.NEW = true;
    this.NewAddress = true;
    if (this.NewAddress == true) {
      this.CurrentAdress = true;
      this.removedata();
      this.new_address_prompt();

      //this.CurrentAdress = false;
    } else {
      this.CurrentAdress = true;
    }
  }

  async new_address_prompt() {
    let alert = await this.alertCtrl.create({
      header: 'Your Address',
      inputs: [
        {
          name: 'street',
          placeholder: 'Street',
        },
        {
          name: 'apt',
          placeholder: 'Apt#',
        },
        {
          name: 'city',
          placeholder: 'City',
        },
        {
          name: 'state',
          placeholder: 'State',
        },
        {
          name: 'zip',
          placeholder: 'Zip',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: (data) => {
            console.log('Cancel clicked');
          },
        },
        {
          text: 'Done',
          handler: (data) => {
            this.Address =
              data.street +
              ',' +
              data.apt +
              ',' +
              data.city +
              ' ' +
              data.state +
              ',' +
              data.zip;
            localStorage.setItem('address', this.Address);
          },
        },
      ],
    });
    alert.present();
  }

  removedata() {
    this.Address = '';
    this.city = '';
    this.zipcode = '';
    this.state = '';
  }

  Updateyourorder() {
    if (this.globals.OrderType == 'delivery') {
      this.checkTimingLater(this.globals.delivery_timing);
    } else {
      this.checkTimingLater(this.globals.pickup_timing);
    }

    if (this.globals.order_time == 'schedule') {
      localStorage.setItem('scheduled_time', this.globals.myDate);
    } else {
      localStorage.setItem('scheduled_time', undefined);
    }

    this.globals.OrderType = 'pickup';
    this.modalCtrl.dismiss();

    this.globals.save_check = true;
  }
  //   checkTiming() {

  //     if (this.globals.OrderType = "delivery") {
  //         console.log("checking timing ");
  //         console.log("global timings", this .globals.Timing);
  //         if (this.globals.Timing) {
  //             let local_datetime = new Date().toLocaleString('en-US', { hour12: false });
  //             this.date = new Date(local_datetime);
  //             console.log("",this.date);
  //             this.scheduled_time = localStorage.getItem("scheduled_time");
  //             this.day = this.date.getDay();
  //             this.time = this.date.getHours();
  //             this.min = this.date.getMinutes();
  //             this.time = this.time + "." + this.min;
  //             console.log("day", "hours", this.day, this.time);
  //             let current_day = this.globals.Timing[this.day];
  //             // this.time = this.time.toString();
  //             console.log(this.time,"current day", current_day );
  //             console.log(this.globals.Timing);
  //             if (current_day[0] != 'opened') {
  //                 if (Number(this.time) <= Number(current_day[0]) || Number(this.time) >= Number(current_day[1]) || current_day[0] == 'closed') {
  //                     let alert = this.alertCtrl.create({
  //                         title: 'Sorry',
  //                         subTitle: 'Restaurants currently closed.',
  //                         buttons: ['OK']
  //                     });
  //                     alert.present();
  //                     return false;
  //                 }
  //                 else {
  //                     return true;
  //                 }
  //             }
  //             else {
  //                 return true;
  //             }

  //         }
  //         else {
  //             console.log("else");
  //             return true;
  //         }
  //     }
  //     else {
  //         console.log("bigelse");
  //         console.log("userDate", this.globals.myDate);
  //         var future_date = new Date(this.globals.myDate);
  //         console.log(future_date);
  //         var future_day = future_date.getDay();
  //         this.globals.myDate = this.globals.myDate.toString();
  //         console.log(this.globals.myDate);
  //         this.future_hours = future_date.getHours();
  //         this.future_min = future_date.getMinutes();

  //         this.future_time = this.future_hours + "." + this.future_min;

  //         console.log("future_hours", this.future_hours, this.future_time);

  //         if (this.globals.Timing) {
  //             console.log(future_day);

  //             var current_day = this.globals.Timing[future_day];
  //             console.log(current_day);

  //             console.log(current_day[0], current_day[1], this.future_time);
  //             //  console.log(parseFloat(time) , parseFloat(current_day[0]),parseFloat(current_day[1]))
  //             if (current_day[0] != 'opened') {
  //                 if (Number(this.future_time) <= Number(current_day[0]) || Number(this.future_time) >= Number(current_day[1]) || current_day[0] == 'closed') {
  //                     let alert = this.alertCtrl.create({
  //                         title: 'Sorry',
  //                         subTitle: 'Restaurants closed on the given time and date.',
  //                         buttons: ['OK']
  //                     });

  //                     alert.present();
  //                     return false;
  //                 }
  //                 else {
  //                     return true;
  //                 }
  //             }
  //             else {
  //                 return true;
  //             }

  //         }
  //         else {
  //             console.log("else");
  //             return true;
  //         }

  //         // return true;
  //     }
  // }

  //   initializeBackButtonCustomHandler(): void {
  //     this.unregisterBackButtonAction = this.plt.registerBackButtonAction(function(event){
  //         console.log('Prevent Back Button Page Change');
  //     }, 101); // Priority 101 will override back button handling (we set in app.component.ts) as it is bigger then priority 100 configured in app.component.ts file */
  // }

  checkTimingLater(timing) {
    return new Promise(async (resolve, reject) => {
      // debugger;
      if (this.globals.order_time == 'schedule') {
        var response: any;

        if (this.globals.specific_delivery_day == 'true') {
          response = this.server.date_convert(
            this.globals.myDate.format('DD-MM-YYYY')
          );
        } else {
          response = this.server.date_convert(this.globals.myDate);
        }
        const toast = await this.toastController.create({
          message: 'Please wait..',
          duration: 500,
          color: 'primary',
        });
        toast.present();
        // let loading = this.loadingCtrl.create({
        //   content: "Loading...",
        // });
        // loading.present();
        response.subscribe(
          (data) => {
            // loading.dismiss();
            if (data.success == true) {
              this.day = data.day_id + 1;
              if (this.day == 7) {
                this.day = 0;
              }
              this.time = data.time;

              this.globals.schedule_day_id = data.day_id;
              this.globals.schedule_converted_time = data.time;

              if (this.globals.specific_delivery_day == 'true') {
                localStorage.setItem(
                  'scheduled_time',
                  this.globals.myDate.format('DD-MM-YYYY')
                );
              } else {
                localStorage.setItem('scheduled_time', this.globals.myDate);
              }
              let current_day = timing[this.day];
              var n = current_day[0].indexOf('.');
              if (n != -1) {
                var res = current_day[0].split('.');
                current_day[0] = res[0] + '.' + '3';
              }
              var n1 = current_day[1].indexOf('.');
              if (n1 != -1) {
                var res = current_day[1].split('.');
                current_day[1] = res[0] + '.' + '3';
              }
              // this.time = this.time.toString();
              console.log(
                'timings and current day ',
                this.day,
                this.time,
                current_day
              );
              if (current_day[0] != 'opened') {
                if (
                  (Number(current_day[0]) <= Number(this.time) &&
                    Number(current_day[1]) > Number(this.time)) ||
                  (Number(current_day[0]) <= Number(this.time) &&
                    Number(current_day[1]) < Number(current_day[0]))
                ) {
                  resolve(true);
                } else if (
                  current_day[0] == 'opened' &&
                  current_day[1] == 'opened'
                ) {
                  resolve(true);
                } else {
                  this.globals.presentToast(
                    'Sorry, we are not serving at this time. Please reschedule it.'
                  );
                  reject(true);
                }
              } else {
                resolve(true);
              }
            }
          },
          (error) => {
            this.globals.presentToast(
              'Something went wrong check your internet connection.'
            );
          }
        );
      } else {
        // debugger;
        console.log('in pickup part 001');
        var date = new Date();
        var day: any = date.getDay();
        var time: any = date.getHours() + '.' + date.getMinutes();
        time = Number(time);

        var current_day = timing[day];

        var n = current_day[0].indexOf('.');

        console.log('in pickup part 002', date, day, time, current_day, n);
        if (n != -1) {
          var res = current_day[0].split('.');
          current_day[0] = res[0] + '.' + '3';
        }
        var n1 = current_day[1].indexOf('.');
        if (n1 != -1) {
          var res = current_day[1].split('.');
          current_day[1] = res[0] + '.' + '3';
        }
        console.log('in pickup part 003', n, n1, current_day, time);
        if (
          (Number(current_day[0]) <= time && Number(current_day[1]) > time) ||
          (Number(current_day[0]) <= time &&
            Number(current_day[1]) < Number(current_day[0]))
        ) {
          resolve(true);
        } else if (current_day[0] == 'opened' && current_day[1] == 'opened') {
          resolve(true);
        } else {
          this.globals.presentToast(
            'Sorry, we are not serving at this time. Please reschedule it.'
          );
          reject(true);
        }
      }
    });
  }
}
